(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-enriq-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('select[name="id"]');
      if (!select) return;
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const button = section.querySelector('.enriq-product-form__submit');
        const price = section.querySelector('[data-product-price]');
        price.replaceChildren();
        if (option.dataset.compare) {
          const compare = document.createElement('s');
          compare.textContent = option.dataset.compare;
          price.append(compare);
        }
        const current = document.createElement('span');
        current.textContent = option.dataset.price;
        price.append(current);
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
    root.querySelectorAll('[data-enriq-tabs]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const tabs = [...section.querySelectorAll('[data-tab-target]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(item => {
          item.setAttribute('aria-selected', String(item === tab));
          item.tabIndex = item === tab ? 0 : -1;
        });
        section.querySelectorAll('[data-tab-panel]').forEach(panel => {
          panel.hidden = panel.dataset.tabPanel !== tab.dataset.tabTarget;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
        });
      });
      section.addEventListener('shopify:block:select', event => {
        const selected = tabs.find(tab => tab.dataset.tabTarget === event.detail.blockId);
        if (selected) activate(selected);
      });
    });
    root.querySelectorAll('.enriq-mobile-menu').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const trigger = menu.querySelector('summary');
      const panel = menu.querySelector('.enriq-mobile-menu__panel');
      const close = () => { menu.open = false; trigger.focus(); };
      menu.querySelector('[data-menu-close]').addEventListener('click', close);
      menu.addEventListener('toggle', () => {
        if (menu.open) panel.querySelector('button').focus();
      });
      menu.addEventListener('keydown', event => {
        if (!menu.open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const items = [...panel.querySelectorAll('a, button, summary')].filter(item => item.getClientRects().length);
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    });
  }
  initialize();
  document.documentElement.classList.remove('no-js');
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.enriq-header__search[open], .enriq-header__dropdown[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
})();
